export default __webpack_public_path__ + "static/media/POINTER_SELECTED.2745f722.svg";